/**
 * ApprovalsLoadAlert Component
 * AIDLC Administrative Backend
 *
 * The failed-load message for the approvals list, with a Try again button that loads the list again in place
 * (PORTAL-RELOAD-1, BL-76e772dc). Shared by the Agent Dashboard panel and the Chat sidebar so both say and do
 * the same thing.
 */

interface ApprovalsLoadAlertProps {
  message: string;
  /** Loads the list again. */
  onRetry: () => void;
  /** True while that load is on its way; the button waits for it. */
  retrying: boolean;
  /** Spacing and size for where it sits. */
  className?: string;
}

export function ApprovalsLoadAlert({ message, onRetry, retrying, className = '' }: ApprovalsLoadAlertProps) {
  return (
    <div
      role="alert"
      className={`flex flex-wrap items-center gap-2 bg-red-50 border border-red-200 text-red-700 ${className}`}
    >
      {/* flex-auto (content-width basis), so on a narrow column the button wraps below the words instead of over them */}
      <span className="flex-auto">{message}</span>
      <button
        type="button"
        onClick={onRetry}
        disabled={retrying}
        aria-busy={retrying}
        className="min-h-[44px] sm:min-h-0 px-3 py-1.5 text-xs font-medium text-red-700 bg-white border border-red-300 rounded-md hover:bg-red-100 transition-colors disabled:opacity-50"
      >
        {retrying ? 'Trying again...' : 'Try again'}
      </button>
    </div>
  );
}
